import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const TrashBinIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6.105 1.48v1.155h3.79V1.481zm5.274 1.155V1.234A1.23 1.23 0 0 0 10.142 0H5.858A1.24 1.24 0 0 0 4.62 1.234v1.401H.742a.741.741 0 1 0 0 1.481h14.516a.741.741 0 1 0 0-1.48zM2.668 5.312a.74.74 0 0 1 .793.686l.575 7.995c.008.14.07.27.174.364l.007.006c.107.1.248.156.395.156h6.776a.59.59 0 0 0 .395-.156l.007-.006a.53.53 0 0 0 .174-.364v-.01l.575-7.985a.742.742 0 0 1 1.48.106l-.574 7.98a2 2 0 0 1-.653 1.365 2.07 2.07 0 0 1-1.4.551H4.608a2.07 2.07 0 0 1-1.401-.551 2 2 0 0 1-.654-1.365l-.573-7.98a.74.74 0 0 1 .687-.792"
      clipRule="evenodd"
    />
  </svg>
);
TrashBinIcon.displayName = 'TrashBinIcon';
export default TrashBinIcon;
